import { render, staticRenderFns } from "./DialogConfirmation.vue?vue&type=template&id=12dbe661&scoped=true"
import script from "./DialogConfirmation.vue?vue&type=script&lang=js"
export * from "./DialogConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbe661",
  null
  
)

export default component.exports